import useAxios from "../../hooks/useAxios";

const useSpectateCwaService = () => {
  const axiosGetAllCwa = useAxios();

  const getCwaFromAppId = async (posId) => {
    await axiosGetAllCwa.fetchData({
      url: `/approver/cwa/${posId}`,
      method: "GET",
      // Admin oversight view — unlike the approver's own queue, this should
      // still show cancelled submissions.
      params: { includeCancelled: true },
    });
  };

  return {
    // list
    getCwaFromAppId,
    cwaLoading: axiosGetAllCwa.loading,
    cwaResponse: axiosGetAllCwa.response,
  };
};

export default useSpectateCwaService;
